import axios from "axios";
import { DbAccess } from "./token";

export function getInfo(access: DbAccess) {
    
    const options = {
        headers: {
            'xc-token': access.token
        }
    };
    return new Promise<BoardApiType>((resolve, reject) => {
        axios.get(import.meta.env.VITE_NOCO_DB_META_TABLE_URL + access.tableId, options)
            .then(res => {
                resolve(res.data)
            }).catch((e) => {
            reject(e)
        })
    });
}
